import { CheckoutParamEnum, PaymentTypeEnum } from 'components/views/pages/Checkout/types';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useCheckoutParams } from './useCheckoutParams';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjs from 'dayjs';
import { dateFormatServer, handleAddDay } from '@alluradirect/react';

dayjs.extend(customParseFormat);
interface Param {
  name: CheckoutParamEnum;
  value: string | number;
}

interface Args {
  isFirstStep: boolean;
}

export const useCheckoutFixInvalidParams = ({ isFirstStep }: Args) => {
  const router = useRouter();

  const { step, adults, pets, children, infants, startDate, endDate, paymentType, marketing } = useCheckoutParams();

  useEffect(() => {
    if (!router.isReady || !step) return;

    const paramsToFix: Param[] = [];

    // to support no guests by default
    if (adults !== undefined || children !== undefined || infants !== undefined) {
      if (!adults || (adults && Number(adults) <= 0)) {
        paramsToFix.push({
          name: CheckoutParamEnum.adults,
          value: 1,
        });
      }
  
      if (!children || (children && Number(children) < 0)) {
        paramsToFix.push({
          name: CheckoutParamEnum.children,
          value: 0,
        });
      }
  
      if (!infants || (infants && Number(infants) < 0)) {
        paramsToFix.push({
          name: CheckoutParamEnum.infants,
          value: 0,
        });
      }
    }

    if (!pets || (pets && Number(pets) < 0)) {
      paramsToFix.push({
        name: CheckoutParamEnum.pets,
        value: 0,
      });
    }

    if (!marketing || (marketing && Number(marketing) < 0) || (marketing && Number(marketing) > 1)) {
      paramsToFix.push({
        name: CheckoutParamEnum.marketing,
        value: 1,
      });
    }

    const noDatesAndNotFirstStep = !isFirstStep && (!startDate || !endDate);
    const isStartDateValid = dayjs(startDate, 'YYYY-MM-DD', true).isValid();
    const isEndDateValid = dayjs(endDate, 'YYYY-MM-DD', true).isValid();
    const today = dateFormatServer(dayjs());

    if (startDate && !isStartDateValid) {
      paramsToFix.push({
        name: CheckoutParamEnum.startDate,
        value: today,
      });
    }

    if (startDate && endDate && !isEndDateValid && isStartDateValid) {
      const nextValidEndDate = dateFormatServer(handleAddDay(startDate ?? today));

      paramsToFix.push({
        name: CheckoutParamEnum.endDate,
        value: nextValidEndDate,
      });
    }

    if (noDatesAndNotFirstStep) {
      paramsToFix.push({
        name: CheckoutParamEnum.step,
        value: 1,
      });
    }

    if (!paymentType) {
      let paymentType_id = 0;
      if( isStartDateValid ){
        paymentType_id = PaymentTypeEnum.PayInFull;
        if( Math.abs(dayjs().diff(dayjs(startDate, 'YYYY-MM-DD', true), 'day')) >= 45 ){
          paymentType_id = PaymentTypeEnum.DepositBalanceDue;
        } else {
          paymentType_id = PaymentTypeEnum.PayInFull;
        }
      } 
      if ( (paymentType && Number(paymentType) > 2) || Number(paymentType) <= 0) {
        paymentType_id = PaymentTypeEnum.PayInFull;
      }
      if( paymentType_id > 0 ){
        paramsToFix.push({
          name: CheckoutParamEnum.paymentType,
          value: paymentType_id,
        });
      }
    } else if( Number(paymentType) == PaymentTypeEnum.DepositBalanceDue && isStartDateValid && Math.abs(dayjs().diff(dayjs(startDate, 'YYYY-MM-DD', true), 'day')) < 45 ){
      paramsToFix.push({
        name: CheckoutParamEnum.paymentType,
        value: PaymentTypeEnum.PayInFull,
      });

    }


    if (paramsToFix.length) {
      router.replace({
        pathname: router.pathname,
        query: {
          ...router.query,
          ...paramsToFix.reduce((curr, next) => {
            const val = {
              ...curr,
              [next.name]: next.value,
            };
            return val;
          }, {}),
        },
      });
    }
  }, [adults, endDate, isFirstStep, children, paymentType, pets, router, startDate, step, infants, marketing]);
};
